/*
 * Copyright (C) 2017 - present Instructure, Inc.
 *
 * This file is part of Canvas.
 *
 * Canvas is free software: you can redistribute it and/or modify it under
 * the terms of the GNU Affero General Public License as published by the Free
 * Software Foundation, version 3 of the License.
 *
 * Canvas is distributed in the hope that it will be useful, but WITHOUT ANY
 * WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS FOR
 * A PARTICULAR PURPOSE. See the GNU Affero General Public License for more
 * details.
 *
 * You should have received a copy of the GNU Affero General Public License along
 * with this program. If not, see <http://www.gnu.org/licenses/>.
 */

import React from 'react'
import GridEvent from './GridEvent'
import type {GridColumn, GridLocation} from '../../grid.d'

export default class Events {
  // Column Changes
  onColumnsResized = new GridEvent<Event, GridColumn[]>()

  // State Changes
  onActiveLocationChanged = new GridEvent<Event, GridLocation>()

  // Keyboard Interaction
  onKeyDown = new GridEvent<React.KeyboardEvent<Element>, GridLocation>()

  // Keyboard Navigation
  onNavigatePrev = new GridEvent<Event, GridLocation>()

  onNavigateNext = new GridEvent<Event, GridLocation>()

  onNavigateLeft = new GridEvent<Event, GridLocation>()

  onNavigateRight = new GridEvent<Event, GridLocation>()

  onNavigateUp = new GridEvent<Event, GridLocation>()

  onNavigateDown = new GridEvent<Event, GridLocation>()
}
